@use '/src/styles/variables.scss';

.open-menu-info-button {
  position: relative;
  z-index: 1;
  color: variables.$in--orange-100;
  margin-left: 0;
  &:hover {
    color: variables.$in--orange-150;
  }
  &:active {
    color: variables.$in--orange-200;
  }
  &__icon {
    font-size: 2rem;
  }
  &__icon-small {
    font-size: 1.5rem;
  }
  // Need additional contrast against tinted surfaces
  // The question mark is a cut-out in the glyph, so a black disc behind it both darkens the mark and gives the ring that lifts the icon off a tinted surface.
  &--bordered &__icon,
  &--bordered &__icon-small {
    background-color: #000000;
    border-radius: 50%;
    box-shadow: 0 0 0 1px #000000;
  }
}
